import FilterConfiguration from "./FilterConfiguration";
export default FilterConfiguration;
